import { render, staticRenderFns } from "./MapNavigationLayers.vue?vue&type=template&id=af489f24&"
import script from "./MapNavigationLayers.vue?vue&type=script&lang=js&"
export * from "./MapNavigationLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HorizontalLayerCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HorizontalLayerCard/index.vue').default,Empty: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Empty/index.vue').default})
